import { hasPermissionGuard } from "../../core/guards";
import { Constants } from "../../shared/constants/constants";
import { PermissionAction } from "../../shared/constants/enums";

export const viewLookupManagementPageGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.view,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.LOOKUP_MANAGEMENT,
        },
      ],
    },
    redirectTo: "/403",
  }),
];

export const createLookupManagementPageGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.create,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.LOOKUP_MANAGEMENT,
        },
      ],
    },
    redirectTo: "/403",
  }),
];

export const manageLookupManagementPageGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.manage,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.LOOKUP_MANAGEMENT,
        },
      ],
    },
    redirectTo: "/403",
  }),
];
